import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from "@ant-design/icons";
import Widget from '../../widget';
import Style from './style';
import { config } from '../../../../components/dashboards/config';
import ProgressBar from '../../../../components/dashboards/components/RiskProgressBar';

const CounterpartyAssessment = ({
  data = 0,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <Widget className="cp-widget no-header">
      <Style>
        <div className="flex">
          <div className="cont">
            <h2>{t('Counterparty Risk')}</h2>
          </div>
          <div className="cont">
            <Tooltip
              title={(
                <>
                  <div style={{ fontWeight: 600, fontSize: 15 }} className='mb-1'>
                    {t('What does this mean')}?
                  </div>
                  <div style={{ maxWidth: 300, fontSize: 13 }}>
                    {t('scaDescription')}
                  </div>
                </>
              )}
            >
              <InfoCircleOutlined
                style={{
                  color: config.TOOLTIP_ICON_COLOR,
                  fontSize: config.TOOLTIP_ICON_SIZE,
                }}
              />
            </Tooltip>
          </div>
        </div>
        <div className="cont">
          <div className="assessment-progress">
            <ProgressBar withTooltip className="lg" percentage={loading ? 0 : data} />
          </div>
        </div>

      </Style>
    </Widget>
  );
}

export default CounterpartyAssessment;
